// Layout.tsx
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Center, Spinner } from "@chakra-ui/react";
import { PageContainer, Wrapper } from "./styles";
import { SideNavProvider } from "@/providers/SideNav";
// 🗑️ REMOVIDO: useAuth, Link, HeaderInfoUser (tudo foi pro SideMenu)
import { SideMenu } from "../UI/Sidemenu/Sidemenu";

function RouteFallback() {
  return (
    <Center h="100%" w="100%">
      <Spinner size="xl" color="#117baa" thickness="3px" />
    </Center>
  );
}

export function Layout() {
  // 🗑️ REMOVIDO: const { user } = useAuth()

  return (
    <SideNavProvider>
      <Wrapper>
        <SideMenu />
        <Page />
      </Wrapper>
    </SideNavProvider>
  );
}

function Page() {
  return (
    <PageContainer
      animate={{
        overflowX: "hidden",
        height: "calc(100vh)",
        background: "#e9ecef",
      }}
    >
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
    </PageContainer>
  );
}
